import React from 'react';
import { Toast, ToastBody } from 'reactstrap';

export default class ScribeNotification extends React.PureComponent {
  background() {
    return this.props.error ? '#fcecec' : '#fcf6eb';
  }

  text() {
    return this.props.error ? '#a94442' : '#8a6d3b';
  }

  border() {
    return this.props.error ? '#e13c3c' : '#e1a93a';
  }

  actionText() {
    return '#a94442';
  }

  render() {
      return (
        <div
          className="position-fixed end-0 p-3"
          style={{
            zIndex: 11,
            top: '6rem'
          }}
        >
          <Toast
            isOpen={this.props.isActive}
            style={{
              fontSize: '1.2rem',
              fontFamily: 'Alegreya Sans',
              backgroundColor: this.background(),
              color: this.text(),
              border: `solid 2px ${this.border()}`,
              bottom: 'inherit',
          }}>
              <ToastBody>{this.props.message} <button href="" className="btn-close float-end" onClick={this.props.onClick}></button></ToastBody>
          </Toast>
        </div>
      );
  }
}
